import { storage } from './storage';
import { clearListFilters } from './listFilters';

/**
 * Session tokens. Access token lives in memory only; the refresh token is persisted (localStorage, try/catch)
 * so a reload can resume the session. Components subscribe through `useSession` (useSyncExternalStore).
 */
const REFRESH_KEY = 'auth.refresh';

type Listener = () => void;

let accessToken: string | null = null;
let accessExpiresAt = 0;
let status: 'unknown' | 'authenticated' | 'anonymous' = storage.get(REFRESH_KEY) ? 'unknown' : 'anonymous';
const listeners = new Set<Listener>();

function emit() {
  listeners.forEach((l) => l());
}

export const session = {
  getAccessToken: () => accessToken,
  getAccessExpiresAt: () => accessExpiresAt,
  getRefreshToken: () => storage.get(REFRESH_KEY),
  getStatus: () => status,

  setTokens(access: string, expiresAtUtc: string, refresh: string) {
    accessToken = access;
    accessExpiresAt = Date.parse(expiresAtUtc) || 0;
    storage.set(REFRESH_KEY, refresh);
    status = 'authenticated';
    emit();
  },

  /** Clears tokens and any per-user browser state (drafts, saved list filters). Logout, rejected refresh and 401 all end here. */
  clear() {
    accessToken = null;
    accessExpiresAt = 0;
    storage.remove(REFRESH_KEY);
    storage.removeByPrefix('draft.');
    clearListFilters();
    storage.removeByPrefix('dashboard:'); // last dashboard tab per user (features/dashboard/access.ts)
    status = 'anonymous';
    emit();
  },

  subscribe(listener: Listener) {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },
};
